import {
  Button,
  FullPageLoad,
  linkPlaceholders,
  navLinks,
  TableView,
  useAxios,
  useExportFile,
  useLoginContext,
} from "common";
import { useParams } from "react-router-dom";

const ExportButton = ({ vendorBrandId, vendorName }) => {
  const { getThisFile, exportLoading } = useExportFile(
    `Brands - ${vendorName || "Vendor"}`,
    `/vendorBrands/${vendorBrandId}/brands/export`
  );
  return (
    <Button loading={exportLoading} onClick={() => getThisFile()}>
      Export
    </Button>
  );
};

const ViewVendorBrand = () => {
  const { vendorBrandId } = useParams();
  const { isPriceSheetsAdmin } = useLoginContext();

  const { response } = useAxios({
    callOnLoad: {
      method: "GET",
      url: `/vendorBrands/${vendorBrandId}`,
    },
  });

  if (!response) return <FullPageLoad fillWidth />;

  const vendor = response.data;

  return (
    <TableView
      url="/brands"
      header={`Brands for ${vendor.name}`}
      tableConfig={[
        { name: "name", header: "Name" },
        { name: "category", header: "Category" },
        { name: "isInactive", header: "Active/Inactive" },
        {
          name: "lastModifiedPricesheet",
          header: "Items Modified",
          isDate: true,
        },
        { name: "lastUploadedBy", header: "Last Uploaded By" },
      ]}
      navLinks={navLinks[isPriceSheetsAdmin ? "brandsForAdmin" : "brands"]}
      linkParam={linkPlaceholders.brandId}
      filterConfig={[{ name: "name", type: "input", label: "Search" }]}
      additionalActions={[
        <ExportButton
          key="export"
          vendorBrandId={vendorBrandId}
          vendorName={vendor.name}
        />,
      ]}
      shapeData={(d) =>
        d.data.data.map((brand) => ({
          ...brand,
          category: brand.category?.name,
          lastUploadedBy: brand.lastUploadedBy?.name,
          isInactive: brand.isInactive ? "In-Active" : "Active",
        }))
      }
      defaultFilters={{
        latestVendorIdUpload: vendorBrandId,
        brand: { $exists: false },
      }}
      defaultParams={{
        populate: "category lastUploadedBy",
        sort: "name",
      }}
    />
  );
};

export default ViewVendorBrand;
